module.exports = __webpack_public_path__ + "static/media/marca-dagua-assiste.0549c6f5.svg";